import { darken, lighten } from 'polished';
import * as React from 'react';
import * as ChatBubbleIcon from 'react-icons/lib/io/chatbubble';
import styled from 'styled-components';

import { TabCtaSettings } from '../../typedefs/store';
import { styledWithProps, tabCtaAnimation } from '../../util/styles';

interface Props {
    ctaClicked: () => void;
    settings: TabCtaSettings;
}

class TabCta extends React.Component<Props, {}> {
    constructor(props: any) {
        super(props);
        this.ctaClicked = this.ctaClicked.bind(this);
    }

    ctaClicked(e: React.MouseEvent<HTMLElement>) {
        e.preventDefault();
        e.stopPropagation();
        this.props.ctaClicked();
    }

    render() {
        const { settings } = this.props;

        return (
            <Positioner settings={settings} className="conversations-cta-container conversations-cta-tab">
                <Tab className="conversations-cta" settings={settings} href="#" onClick={this.ctaClicked}>
                    <Flex>
                        <ChatIcon size={28} />
                        <div>{settings.ctaText}</div>
                    </Flex>
                </Tab>
            </Positioner>
        );
    }
}

export default TabCta;

const getPositionRight = (ctaPosition: string): string => {
    switch (ctaPosition) {
        case 'bottom right':
            return '40px';
        case 'bottom left':
            return 'auto';
        case 'left':
            return 'auto';
        case 'right':
        default:
            return '0px';
    }
};

const getPositionLeft = (ctaPosition: string): string => {
    switch (ctaPosition) {
        case 'bottom right':
            return 'auto';
        case 'bottom left':
            return '40px';
        case 'left':
            return '0px';
        case 'right':
        default:
            return 'auto';
    }
};

const getPositionBottom = (ctaPosition: string): string => {
    switch (ctaPosition) {
        case 'bottom right':
        case 'bottom left':
            return '0px';
        case 'left':
        case 'right':
        default:
            return '400px';
    }
};

const getRotation = (ctaPosition: string): string => {
    switch (ctaPosition) {
        case 'bottom right':
        case 'bottom left':
            return '0';
        case 'left':
            return '90';
        case 'right':
        default:
            return '270';
    }
};

const getTransformOrigin = (ctaPosition: string): string => {
    switch (ctaPosition) {
        case 'bottom right':
        case 'bottom left':
            return 'inherit';
        case 'left':
            return 'left bottom';
        case 'right':
        default:
            return 'right bottom';
    }
};

const Positioner = styledWithProps<{ settings: TabCtaSettings }>(styled.div)`
    box-sizing: border-box;
    position: fixed;
    right: ${props => getPositionRight(props.settings.ctaPosition)};
    left: ${props => getPositionLeft(props.settings.ctaPosition)};
    bottom: ${props => getPositionBottom(props.settings.ctaPosition)};
    transform: rotate(${props => getRotation(props.settings.ctaPosition)}deg);
    transform-origin: ${props => getTransformOrigin(props.settings.ctaPosition)};
    z-index: 1220000;
    transition: transform 0.15s ease-in;
    &:hover, &:active {
        transform: scale(1.05) rotate(${props => getRotation(props.settings.ctaPosition)}deg);
    }
`;

const Tab = styledWithProps<{ settings: TabCtaSettings }>(styled.a)`
    display: block;
    padding: 10px 20px 7px 20px;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    background-color: ${props => props.settings.ctaBackgroundColor};
    color: ${props => props.settings.ctaForegroundColor};
    transition: all 0.15s ease-in;
    &:hover, &:active {
        color: ${props => props.settings.ctaForegroundColor};
        background-color: ${props => lighten(0.02, props.settings.ctaBackgroundColor)};
    }
    border-top: 4px solid;
    border-top-color: ${props => darken(0.2, props.settings.ctaBackgroundColor)};
    text-transform: uppercase;
    text-decoration: none;
    font-family: sans-serif;
    font-weight: 300;
    ${tabCtaAnimation}
`;

const Flex = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ChatIconBase = styledWithProps<{ size: number }>(styled(ChatBubbleIcon));

const ChatIcon = ChatIconBase`
    margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Cta/Tab.tsx